import config from '../../../config/product.json'

// The product's public identity, read from config/product.json — the one place
// the name is spelled (ONB-099). Rails reads the same file into
// YvereAgent::PRODUCT_NAME / PRODUCT_HANDLE / PRODUCT_TAGLINE, so the ERB
// layout, the mailer, the PWA manifest and every Inertia surface agree.
export const product = {
  name: config.name,
  handle: config.handle,
  parentName: config.parent_name,
  stageLabel: config.stage_label,
  tagline: config.tagline,
  // How the agent is addressed in Slack copy: Slack renders an app mention as
  // "@" + the bot's display name, and inside Slack the agent is called by its
  // handle (P30: `baby-every`), not the long product name.
  mention: `@${config.handle}`,
  // The palette seats the browser chrome reads (theme-color, the PWA
  // manifest); the CSS custom properties --bright-blue / --off-white are the
  // same values.
  brand: { themeColor: config.brand.theme_color, backgroundColor: config.brand.background_color },
} as const

export type Product = typeof product
